var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "news-feed-page container homebase-container pt-5 pb-5" },
    [
      _c("div", [_c("back-to-home-button")], 1),
      _vm._v(" "),
      _c("news-feed", {
        attrs: {
          title: _vm.formattedTitle,
          posts: _vm.posts,
          topics: _vm.topics,
          "is-loading": _vm.isLoading,
          "is-errored": _vm.isErrored,
          "is-full-page": true,
          "enable-edit-interests": _vm.enableByInterests,
          "enable-load-more": true,
          "show-load-more": _vm.showLoadMore,
          "is-more-loading": _vm.isMoreLoading
        },
        on: {
          onLoadMore: _vm.handleLoadMoreClicked,
          interestsSaved: _vm.resetNewsFeed
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2423bd7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2423bd7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/NewsFeedPage.vue
// module id = null
// module chunks = 